import { UTILS } from "../config/API";

export const fetchProfileData = async () => {
  try {
    const response = await fetch(UTILS, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: new URLSearchParams({
        action: "prof",
      }),
    });

    const data = await response.json();

    if (response.ok) {
      sessionStorage.setItem("accountType", data["Account Type"]);
      sessionStorage.setItem("fullname", data["Full Name"]);

      // If response is array, save selectedTaxPayer if not set
      if (Array.isArray(data)) {
        if (!localStorage.getItem("selectedTaxPayer") && data.length > 0) {
          localStorage.removeItem("selectedTaxPayer"); // Clear if any stale
          localStorage.removeItem("selectedBusinessName");

          // No selectedTaxPayer yet, user must select
        }
      } else {
        // If single profile object, clear tax payer
        localStorage.removeItem("selectedTaxPayer");
        localStorage.removeItem("selectedBusinessName");

      }

      return data;
    } else {
      throw new Error(data.message || "Failed to fetch profile data");
    }
  } catch (error) {
    console.error("Error fetching profile data:", error);
    throw error;
  }
};
